import * as actionTypes from '../actions/actionsTypes';

const initialState = {
  usersList: {
    data: []
  },
};

export const usersListReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_USERS_LIST_BY_CLUB:
      return {
        ...state,
        usersList: action.payload,
      };
    case actionTypes.FETCH_ALL_USERS_LIST:
      return {
        ...state,
        usersList: action.payload,
      };
    default:
      return state;
  }
};
